import { isIOS } from '@e3dc-react/shell/Configuration'
import React from 'react'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { REQUIRED_FLOW_R3_VERSION } from '../const'
import AppUpdateWrapper from './AppUpdateWrapper'

type Props = {
  children: React.ReactNode
}

/**
 * Wrapper that enforces a minimum app version for users in the Flow theme
 */
const FlowThemeAppVersionEnforcer: React.FC<Props> = ({ children }) => {
  const {
    featureFlags: { minimumRequiredAppVersionForFlow },
    isFeatureFlagsLoading,
    isFeatureFlagsError,
  } = useFeatureFlagsContext()

  const requiredAppVersion = isIOS ? minimumRequiredAppVersionForFlow?.iOS : minimumRequiredAppVersionForFlow?.android

  if (isFeatureFlagsError) return children
  if (isFeatureFlagsLoading) return null
  return (
    <AppUpdateWrapper
      requiredAppVersion={{
        flow: requiredAppVersion || REQUIRED_FLOW_R3_VERSION,
      }}
      activeForIos
      activeForAndroid
    >
      {children}
    </AppUpdateWrapper>
  )
}

export default FlowThemeAppVersionEnforcer
